'use strict';

angular.module('msWidgets').directive('msWidgetButtonRevealSequentialImg', [function () {
  return {
    templateUrl: 'widgets/templates/button/reveal_sequential_img.html',
    controller: 'SequentialRevealCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}]).directive('msWidgetButtonRevealSequentialText', [function () {
  return {
    templateUrl: 'widgets/templates/button/reveal_sequential_text.html',
    controller: 'SequentialRevealCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}]).directive('msWidgetButtonRevealButtonsText', [function () {
  return {
    templateUrl: 'widgets/templates/button/reveal_buttons_text.html',
    controller: 'NonSequentialRevealCtrl',
    controllerAs: '$ctrl'
  };
}]).controller('SequentialRevealCtrl', ['$scope', '$log', '$timeout', function ($scope, $log, $timeout) {
  var vm = this;
  vm.selected = {
    show: 0
  };

  vm.hideButton = false;
  vm.next = function () {
    $log.debug('Clicked Forward button - ', vm.selected);
    vm.hideButton = vm.selected.show + 1 >= $scope.widget.properties.size - 1;
    //delaying the show on the next item until after the hide button trigger occurs
    $timeout(function () {
      vm.selected.show = vm.selected.show + 1;
      $scope.$digest();
    }, 500, false);
  };
}]).controller('NonSequentialRevealCtrl', ['NotifyingSvc', function (NotifyingSvc) {
  var vm = this;

  vm.revealText = function (input) {
    NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
      inputs: {
        heading: input.choice,
        body: input.text
      }
    });
  };
}]);